import React from 'react';
import './CoachInitiationPage.css';

interface CoachInitiationPageProps {
  onSearchPlayer: () => void;
  onCreateNewEvaluation: () => void;
  onViewMyPlayers: () => void;
  onVideoAnalysis?: () => void;
  onExit: () => void;
}

const CoachInitiationPage: React.FC<CoachInitiationPageProps> = ({
  onSearchPlayer,
  onCreateNewEvaluation,
  onViewMyPlayers,
  onVideoAnalysis,
  onExit,
}) => {
  return (
    <div className="coach-initiation-page">
      <div className="coach-initiation-container">
        <h2>What would you like to do?</h2>
        <div className="action-buttons">
          <button 
            className="action-btn search-btn" 
            onClick={onSearchPlayer}
          >
            Search for Existing Player
          </button>
          <button 
            className="action-btn create-btn" 
            onClick={onCreateNewEvaluation}
          >
            Create New Player Evaluation
          </button>
          <button 
            className="action-btn players-btn" 
            onClick={onViewMyPlayers}
          >
            View all My Players
          </button>
          {onVideoAnalysis && (
            <button 
              className="action-btn video-analysis-btn" 
              onClick={onVideoAnalysis}
            >
              Video Analysis
            </button>
          )}
          <button 
            className="action-btn exit-btn" 
            onClick={onExit}
          >
            Exit
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoachInitiationPage;





